<script lang="ts">
  import { page } from "$app/stores";

  import { onMount } from "svelte";

  import FeatureMaturityChip from "$lib/design-systems/product/primitives/chips/FeatureMaturityChip.svelte";
  import { centerInView } from "$routes/(docs)/docs/_lib/scroll";
  import type { DocsSection } from "../_lib/sections";

  interface Props {
    section: DocsSection;
    dumbHeader?: boolean;
    monoItems?: boolean;
  }

  let { section, dumbHeader = false, monoItems = false }: Props = $props();

  let activeElement: HTMLElement | undefined;
  function setActive(element: HTMLElement) {
    activeElement = element;
  }
  onMount(() => {
    if (activeElement) centerInView(activeElement);
  });
</script>

{#if "href" in section}
  {@const isActive = $page.url.pathname == section.href}
  <a
    href={section.href}
    class="header"
    class:active={isActive}
    {@attach isActive && setActive}
  >
    <span class="flex flex-wrap items-center gap-x-1.5 gap-y-1">
      <span>{section.title}</span>
      {#if section.maturity}
        <FeatureMaturityChip maturity={section.maturity} />
      {/if}
    </span>
  </a>
{:else}
  <a href={section.pages.at(0)?.href} class="header" class:dumb={dumbHeader}>
    {section.title}
  </a>
  {#each section.pages as item}
    {@const isActive = $page.url.pathname == item.href}
    <a
      href={item.href}
      class="item"
      class:active={isActive}
      class:font-mono={monoItems}
      {@attach isActive && setActive}
    >
      <span class="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        <span>{item.title}</span>
        {#if item.maturity}
          <FeatureMaturityChip maturity={item.maturity} />
        {/if}
      </span>
    </a>
  {/each}
{/if}

<style lang="postcss">
  @reference "$app.css";

  .header {
    @apply border-l border-secondary py-2 pl-4 text-sm text-secondary-bold hover:bg-primary-hover active:bg-primary-active;
  }
  .item {
    @apply border-l border-secondary py-2 pr-2 pl-8 text-sm text-secondary hover:bg-primary-hover active:bg-primary-active;
  }
  .active {
    @apply border-accent-selected bg-elevated font-medium;
  }
  .header.dumb {
    @apply pointer-events-none bg-none;
  }
</style>
